<template>
    <div>
        <az-call-to-action dark
                           :active="propostaResumo.podeEnviar"
                           :outline="!propostaResumo.podeEnviar"
                           @click="verificarDocumentosHabilitacaoProposta"
                           class="no-mobile">
            Enviar Propostas
        </az-call-to-action>
        <!--confirmacao envio da proposta -->
        <az-confirm v-if="mostrarConfirmacaoEnviarProposta" :maxWidth=320
                    @onConfirm="confirmarEnvioProposta" @onDecline="fecharConfirmacaoEnviarProposta">
            Deseja realmente enviar a proposta?
        </az-confirm>
      <az-confirm v-if="mostrarModalAlertaSemDocumentos" :maxWidth=450
                  labelDecline="ENVIAR MESMO ASSIM" label-confirm="VOLTAR PARA ANEXAR"
                  @onConfirm="verificarDocumentos" @onDecline="fecharModalAnexoDocumentos">
        <div class="texto-modal-habilitacao">
          <v-icon color="#FFD22D">warning</v-icon>
          <label>
            Identificamos que não existem documentos de
            <template v-if="alertaDocsProposta"> proposta</template>
            <template v-if="alertaDocsHabilitacao && alertaDocsProposta"> e</template>
            <template v-if="alertaDocsHabilitacao"> habilitação</template>
            anexados à sua proposta, certifique-se das exigências do edital do processo
            quanto a documentação.
          </label>
        </div>
      </az-confirm>
        <!--protocolo gerado-->
        <az-dialog v-if="mostrarDialogProtocolo" @ok="finalizarEnvio()">
            <wrapper-dialog>
                <div class="dialog-sucesso">
                    <span class="dialog-title">Proposta enviada com sucesso</span><br/>
                    <span class="dialog-text">Protocolo gerado: {{protocoloGerado.numero}}</span>
                </div>
            </wrapper-dialog>
        </az-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {actionTypes, tiposLicitacao} from '@/commons/constants'
    import WrapperDialog from '@/commons/components/WrapperDialog.vue'
    import validadorProposta from '../proposta/credenciamento-fornecedor-proposta-validador'

    export default {
        name: 'CredenciamentoFornecedorAcoesEnviar',
        components: {WrapperDialog},
        component: {
            WrapperDialog
        },
        data() {
            return {
                globalLoadingAtivado: false,
                mostrarConfirmacaoEnviarProposta: false,
                mostrarDialogProtocolo: false,
                protocoloGerado: {},
                documentos: [],
                mostrarModalAlertaSemDocumentos: false,
                alertaDocsHabilitacao: false,
                alertaDocsProposta: false,
            }
        },
        computed: {
            isMenorPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
            },
            ehModoManual(){
              return this.parametros.propriedadesLicitacao.modoCriacaoProcesso === 'MANUAL'
            },
            ...mapState(['licitacao', 'loki', 'propostaResumo', 'parametros'])
        },
        methods: {
            abrirDialogProtocolo() {
                this.mostrarDialogProtocolo = true
            },
            async confirmarEnvioProposta() {
                this.fecharConfirmacaoEnviarProposta()
                this.habilitarLoading()
                try {
                    let planoFornecedor = await this.buscarDadosAssinaturasFornecedor()
                    if (!planoFornecedor.assinaturaAtual) {
                        this.mostrarNotificacaoErro('Plano expirado, não foi possível efetuar o envio de propostas.')
                        return
                    }
                    const isPropostaValida = await this.isPropostaComItensValidosParaEnvio()
                    if (!isPropostaValida) {
                        this.mostrarNotificacaoErro('Não foi possível realizar o envio da proposta pois existem itens com preenchimento incompleto.')
                        return
                    }
                    if(this.licitacao.status !== 'AGUARDANDO_ABERTURA'){
                      this.mostrarNotificacaoErro('Só é possível efetuar propostas em licitações com o status "Aguardando Abertura".')
                      return
                    }
                    await this.efetuarEnvioProposta()
                    this.abrirDialogProtocolo()
                    this.desabilitarLoading()
                } catch (e) {
                    this.desabilitarLoading()
                }
            },
            desabilitarLoading() {
                if (!this.globalLoadingAtivado) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async efetuarEnvioProposta() {
                this.setMensagemLoading('Enviando proposta...')
                this.protocoloGerado = await this.enviarProposta({licitacaoId: this.licitacao.id})
                this.$emit('atualizarProposta')
            },
            fecharConfirmacaoEnviarProposta() {
                this.mostrarConfirmacaoEnviarProposta = false
            },
            fecharDialogProtocolo() {
                this.mostrarDialogProtocolo = false
            },
            async finalizarEnvio() {
                this.habilitarLoading()
                try {
                    await this.sincronizarProposta()
                    this.fecharDialogProtocolo()
                    this.desabilitarLoading()
                } catch (e) {
                    this.fecharDialogProtocolo()
                    this.desabilitarLoading()
                }
            },
            habilitarLoading() {
                this.globalLoadingAtivado = this.loki.isGlobalLoadingEnabled
                this.habilitarLoadingGlobal()
            },
            async isPropostaComItensValidosParaEnvio() {
                const propostaItens = await this.buscarLicitacaoPropostaItens(this.licitacao.id)
                return validadorProposta.validar(propostaItens, this.isMenorPreco)
            },
            async sincronizarProposta() {
                this.setMensagemLoading('Carregando dados da Proposta...')
                await this.buscarPropostaResumo(this.licitacao.id)
            },
            async verificarDocumentosHabilitacaoProposta(){
              await this.buscarDocumentos()
              const docsHabilitacao = this.documentos.filter(doc => doc.tipoAnexo === 'ANEXO_HABILITACAO')
              const docsProposta = this.documentos.filter(doc => doc.tipoAnexo === 'ANEXO_PROPOSTA')
              this.alertaDocsHabilitacao = docsHabilitacao.length === 0
              this.alertaDocsProposta = !this.ehModoManual && (docsProposta.length === 0 || docsProposta.length === 1 && docsProposta[0].tipoDocumento === 'ACEITE_TERMOS')
              if(this.alertaDocsHabilitacao || this.alertaDocsProposta){
                this.mostrarModalAlertaSemDocumentos = true
              }else{
                this.mostrarConfirmacaoEnviarProposta = true
              }
            },
            fecharModalAnexoDocumentos(){
              this.mostrarModalAlertaSemDocumentos = false
              this.mostrarConfirmacaoEnviarProposta = true
            },
            verificarDocumentos(){
              if(this.$route.name !== 'credenciamentoFornecedorDocumentos'){
                this.$router.push({name: 'credenciamentoFornecedorDocumentos', params: {id: this.licitacao.id}})
              }
              this.mostrarModalAlertaSemDocumentos = false
              this.mostrarConfirmacaoEnviarProposta = false
            },
            async buscarDocumentos() {
              this.documentos = await this.buscarDocumentosSolicitacaoCredenciamento(this.licitacao.id)
            },
            temAmparoLei14133Incluso() {
              const amparoLegal = this.licitacao.amparoLegal
              return amparoLegal && /^Lei 14\.133\/2021, Art\. \d+\,/.test(amparoLegal.lei);
            },
            ...mapActions([
                actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO,
                actionTypes.BUSCAR_PROPOSTA_RESUMO,
                actionTypes.BUSCAR_LICITACAO_PROPOSTA_ITENS,
                actionTypes.ENVIAR_PROPOSTA,
                actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR
            ])
        }
    }
</script>

<style lang="stylus" scoped>

.texto-modal-habilitacao
    text-align justify

</style>
